import { createApp } from 'vue'
import App from './apps/TravelForm/App.vue'

document.addEventListener("turbo:load", () => {
  const mountEl = document.querySelector("#travelForm");
  if (mountEl){
    mountEl.style.display = "grid"

    let i18n = {}

    if (mountEl.innerHTML.startsWith("<path>")){
      function atobUTF8(data) {
          const decodedData = atob(data);
          const utf8data = new Uint8Array(decodedData.length);
          const decoder = new TextDecoder("utf-8");
          for (let i = 0; i < decodedData.length; i++) {
              utf8data[i] = decodedData.charCodeAt(i);
          }
          return decoder.decode(utf8data);
      }
      let html1 = mountEl.innerText.replaceAll("<path>", "")
      html1 = html1.replaceAll("</path>", "")
      html1 = html1.replaceAll("\n", "")
      let locals = html1.split(";").map( x => x.split(":"))
      locals.forEach(x => {
        i18n[atobUTF8(x[0])] = x[1]
      })
    }

    const app = createApp(App, {
      settings: mountEl.dataset,
      i18n: i18n,
    })
    app.mount('#travelForm')
  }
});

